module.exports = __webpack_public_path__ + "img/sup_vip_class_upgrading_banner.e43a0248.jpg";